import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { HtmlSafe } from 'polaris-coreweb/exports';
import { withPolaris } from 'Components/protons/Polaris';
import { Image } from 'Components/atoms/Image';
import { getAuthorsForJsonLd } from 'SharedHelpers/getAuthorsForJsonLd';
import './_style.scss';

const PullQuoteBlock = ({ author, content, context: { cssPrefix } }) => {
  const authorsSchema = author && !Array.isArray(author) && getAuthorsForJsonLd({ authors: [author], siteUrl: '', siteName: '' });

  const jsonld = {
    '@context': 'https://schema.org',
    '@type': 'Quotation',
    creator: authorsSchema || [],
    text: content,
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(jsonld);
    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, [jsonld]);

  return (
    <div className={`${cssPrefix}__pull-quote-block`}>
      {author?.image?.src && (
        <div className={`${cssPrefix}__pull-quote-block--media`}>
          <Image size="author" {...author.image} />
        </div>
      )}
      <div className={`${cssPrefix}__pull-quote-block--content`}>
        <blockquote>
          <div className={`${cssPrefix}__pull-quote-block--content--quote`}>
            {content && <HtmlSafe html={content} />}
          </div>
          {author?.name && (
            <cite>
              -&nbsp;
              {author.name}
              {author.jobTitle && `, ${author.jobTitle}`}
            </cite>
          )}
        </blockquote>
      </div>
    </div>
  );
};

PullQuoteBlock.propTypes = {
  author: PropTypes.shape({
    image: PropTypes.shape({
      src: PropTypes.string,
    }),
    name: PropTypes.string,
    jobTitle: PropTypes.string,
  }),
  content: PropTypes.string,
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
};

PullQuoteBlock.defaultProps = {
  author: {
    image: {
      src: '',
    },
    name: '',
    jobTitle: '',
  },
  content: '',
  context: {
    cssPrefix: 'polaris',
  },
};

export default withPolaris(PullQuoteBlock);
